import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type PostUserCompareParam = {
  postalCode: string;
  childrenCount: string;
  birthYear: string;
  annualSalary: string;
  children: { order: number; grade: string }[];
};

export type UnregistredUserCompare = {
  postalCode: string | null;
  childrenCount: string | number | null;
  birthYear: string | null;
  annualSalary: string | number | null;
  children?: { order: number; grade: string }[] | null;
  childrenColumn1?: string | null;
  childrenColumn2?: string | null;
  childrenColumn3?: string | null;
  childrenColumn4?: string | null;
  childrenColumn5?: string | null;
};


export type PostUserCompareEvaluation = {
  requestKey: string | null;
  evalutionComment: string | null;
  requestValue: number | null;
  avarageValue: number | null;
  evalutionActionList:[] | null;
  evaluationImage: string | null;
};

export type PostUserCompareEvaluationParam = {
  requestKey: string;
  requestValue: string | number;
};


const unregisteredCompareUri = "api/unregistered-users/user-compare";
const unregisteredEvaluationUri = "api/unregistered-users/user-compare-evaluation";

const registeredCompareUri = "api/users/user-compare";
const registeredEvaluationUri = "api/users/user-compare-evaluation";

export const postUserCompareResponseAtom = atom<State<null> | null>(null);

export const fetchCompareContentAtom = atom<State<UnregistredUserCompare> | null>(null);
export const fetchUnregisteredCompareContent = () => {
    return fetchBase<UnregistredUserCompare>(unregisteredCompareUri, fetchCompareContentAtom);
};

export const postCompareEvalutionContentAtom = atom<State<PostUserCompareEvaluation> | null>(null);
export const postUnregisteredCompareEvaluationContent = () => {
    return postBase<PostUserCompareEvaluation, PostUserCompareEvaluationParam>(
      unregisteredEvaluationUri,
      postCompareEvalutionContentAtom
    );
};

export const postRegisteredCompareEvaluationContent = () => {
    return postBase<PostUserCompareEvaluation, PostUserCompareEvaluationParam>(
      registeredEvaluationUri,
      postCompareEvalutionContentAtom
    );
};

export const postUnregisteredUserCompare = () => {
  return postBase<null, PostUserCompareParam>(
    unregisteredCompareUri,
    postUserCompareResponseAtom
  );
};

export const postRegisteredUserCompare = () => {
  return postBase<null, PostUserCompareParam>(
    registeredCompareUri,
    postUserCompareResponseAtom
  );
};
